export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.49d5a502.svg";